import { IdentificationDocumentTypes } from "./MasterData";

export class DocumentNumberModalOutput {
  documentType: IdentificationDocumentTypes;
  documentNumber: string;
}
